import images from "../images/images";

function BackButton({title,handleBackClick}) {

    function handleBackClick() {
          window.history.back();
      }
  
    return (<div className="progress-header-back-row">
          <img
            src={images["icon_back"]}
            className="progress-back-button"
            onClick={handleBackClick}
            aria-label="Back"
            alt="Back"
           />
            <div className="mapOverview-profile-text">{title}</div>

        </div>);

    }


export { BackButton}